import UserShortCut from 'components/common/UserShortCut';
import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { ChatHeader } from '../types/types';
import { useSignalR } from 'contexts/SignalRProvider';
import {
  MintHrDropdown,
  MintHrDropdownItem,
} from 'components/common/MintHrDropdown';
import { useTranslation } from 'react-i18next';
import {
  deleteGroupServices,
  GetGroupDetailsByIdServices,
} from '../services/chatServices';
import { useSidebarManager } from 'contexts/SidebarManagerContext';
import CreateGroupe from './CreateGroupe';
import { useDialog } from 'contexts/DialogContext';
import { toast } from 'react-toastify';

interface HeaderInfoProps {
  headerInfo: ChatHeader;
  setShowGroupDetail: React.Dispatch<React.SetStateAction<boolean | null>>;
  setRefresh: Dispatch<SetStateAction<boolean>>;
  setHeaderInof: React.Dispatch<React.SetStateAction<ChatHeader | null>>;
  onBack?: () => void;
}
const HeaderMessage: React.FC<HeaderInfoProps> = ({
  headerInfo,
  setShowGroupDetail,
  setRefresh,
  setHeaderInof,
  onBack,
}) => {
  const [userStatus, setUserStaus] = useState<null | string>(null);
  const { isConnected, connection } = useSignalR();
  const { openSidebar } = useSidebarManager();
  const { t } = useTranslation();
  const dialog = useDialog();
  useEffect(() => {
    if (connection && isConnected) {
      connection?.on(
        'UserStatus',
        function (userid: string, online: string, lastactivitydate: string) {
          if (headerInfo?.id == userid) {
            if (online) {
              setUserStaus('en ligne');
            } else if (!online) {
              if (lastactivitydate == null) {
                setUserStaus('');
              } else {
                setUserStaus(lastactivitydate);
              }
            }
          }
        },
      );
    }
  }, [connection, isConnected, headerInfo?.id]);

  const handelEditGroup = async (): Promise<void> => {
    const response = await GetGroupDetailsByIdServices(Number(headerInfo.id));
    if (!response.success) {
      toast.error(response.message);
      return;
    }
    openSidebar(CreateGroupe, false, {
      group: response.data,
      setRefresh,
    });
  };

  const handelDeleteGroup = (): void => {
    dialog
      .delete('Chat.message.delete.title', 'Chat.message.delete.description')
      .then(async (result) => {
        if (result) {
          const reponse = await deleteGroupServices(Number(headerInfo.id));
          if (reponse.success) {
            setRefresh((prev) => !prev);
            setHeaderInof(null);
            toast.success(t('Default.succesMessage'));
          } else {
            toast.error(reponse.message);
          }
        }
      });
  };
  const isOnline = userStatus === 'en ligne';

  return (
    <div className="tw-flex tw-w-full tw-items-center tw-gap-3 currentuser">
      {onBack && (
        <button
          type="button"
          onClick={onBack}
          className="tw-flex tw-items-center tw-justify-center tw-w-9 tw-h-9 tw-rounded-md tw-bg-transparent hover:tw-bg-light-gray2 tw-border-none tw-shrink-0 tw-cursor-pointer tw-transition tw-rotate-180"
          aria-label={t('back', { defaultValue: 'Back' })}
        >
          <img
            className="tw-w-3 tw-h-3 tw-icon-gray"
            src="/icons/arrow.svg"
            alt=""
          />
        </button>
      )}

      <div className="tw-relative tw-shrink-0">
        {!headerInfo.isGroup ? (
          <UserShortCut
            className=" tw-w-9 tw-h-9 tw-rounded-full tw-object-cover tw-border tw-border-light-gray3 tw-shadow-sm"
            src={`upload/profileimages/${headerInfo.id}/${headerInfo.imagePath}`}
            alt=""
          />
        ) : (
          <img
            className=" tw-w-9 tw-h-9 tw-rounded-full tw-object-cover tw-border tw-border-light-gray3 tw-shadow-sm"
            src={`/upload/profileimages/${headerInfo.id}/${headerInfo.imagePath}`}
            alt=""
          />
        )}
      </div>

      <div className="tw-min-w-0 tw-flex-1">
        <span
          onClick={() => {
            if (headerInfo.isGroup) setShowGroupDetail(true);
          }}
          className={`tw-truncate tw-text-[calc(var(--unit-minthr)*12)] tw-font-bold tw-text-dark tw-m-0 ${
            headerInfo.isGroup ? 'tw-cursor-pointer hover:tw-text-primary' : ''
          } tw-transition`}
        >
          {headerInfo.name}
        </span>
        <span className="tw-text-[calc(var(--unit-minthr)*10)] tw-text-dark-gray3 tw-m-0  tw-flex tw-items-center tw-gap-1 lastactivity">
          {isOnline && (
            <span className="tw-w-1.5 tw-h-1.5 tw-rounded-full tw-bg-success" />
          )}
          <span className="tw-truncate">{userStatus ?? ''}</span>
        </span>
      </div>

      {headerInfo.isGroup && (
        <>
          <div className="tw-flex tw-items-center mobile:tw-hidden team-members">
            {headerInfo.groupMembers.slice(0, 3).map((item, index) => (
              <UserShortCut
                key={index}
                className="tw-w-7 tw-h-7 tw-rounded-full tw-border-2 tw-border-white tw--mr-1.5 tw-max-w-max tw-shadow-sm"
                src={`upload/profileimages/${item.id}/${item.birthday}`}
                alt=""
              />
            ))}
            {headerInfo.groupMembers.length > 3 && (
              <span className="tw-w-7 tw-h-7 tw-rounded-full tw-border-2 tw-border-white tw--mr-1.5  tw-bg-light-gray3 tw-text-dark tw-text-[calc(var(--unit-minthr)*10)] tw-font-semibold tw-flex tw-items-center tw-justify-center">
                +{headerInfo.groupMembers.length - 3}
              </span>
            )}
          </div>
          <div className="dropdown tw-relative group-dropdown">
            <MintHrDropdown
              title={
                <button
                  className="dropdown-toggle tw-flex tw-items-center tw-justify-center tw-w-9 tw-h-9 tw-rounded-full  hover:tw-bg-light-gray3 tw-border-none tw-transition"
                  type="button"
                >
                  <img
                    className="tw-w-3.5 tw-h-3.5 tw-icon-gray tw-rotate-180"
                    src="/icons/options-dots.svg"
                    alt=""
                  />
                </button>
              }
            >
              <MintHrDropdownItem
                onClick={() => {
                  setShowGroupDetail(true);
                }}
              >
                {t('chat.see.Details')}
              </MintHrDropdownItem>
              {headerInfo.isAdmin && (
                <>
                  <MintHrDropdownItem onClick={handelEditGroup}>
                    {t('edit')}
                  </MintHrDropdownItem>
                  <MintHrDropdownItem onClick={handelDeleteGroup}>
                    {t('delete')}
                  </MintHrDropdownItem>
                </>
              )}
            </MintHrDropdown>
          </div>
        </>
      )}
    </div>
  );
};

export default HeaderMessage;
